import {
    useMutation,
    UseMutationOptions,
    useQuery
} from "@tanstack/react-query";
import { AnfragenManagerClient, get, post } from "lib/httpService";
import { IManuallyLeadFormDto, ImportLeadInformation } from "./dto";
import { getimportLead, postimportLead } from "constants/reactQueryKey";
import ApiError from "lib/ApiError";

export const useGetImportLeadById = (secureId: string, options = {}) => {
    return useQuery(
        [getimportLead, secureId],
        async () => {
            return await get<ImportLeadInformation>(
                `/lead/GetImportListLeadById/${secureId}`,
                AnfragenManagerClient
            );
        },
        {
            ...options
        }
    );
};

export const usePostCreateImportLead = (
    options: UseMutationOptions<
        void,
        ApiError,
        IManuallyLeadFormDto,
        unknown
    > = {}
) => {
    return useMutation<void, ApiError, IManuallyLeadFormDto>({
        mutationKey: [postimportLead],
        mutationFn: (data: IManuallyLeadFormDto) =>
            post(`/lead/CreateImportLead`, data, AnfragenManagerClient),
        ...options
    });
};
